module.exports = __webpack_public_path__ + "img/porteGalandageAv.2db97eff.png";